import React from 'react';
import {
    Upload,
    Review,
    Errors,
    Success,
    VesselPositionSummary,
} from 'components/forms/sections';
import {Route} from 'react-router-dom';
import ProgressForm from 'components/forms/ProgressForm';
import {FormNames, FormTypes} from '../../../constants';
import {StatePrompt} from 'components/forms';
import fields from './fields';
import {mapFieldLabels} from 'components/utils/field-label-mappings';
import {
    LetterSummary,
    Signature,
    ShipmentAndDischarge,
    RatingFactory,
    //OffshoreTrainee,
    Watertype,
    AssociateTankerman,
} from './sections';
import {Branch, BranchGroup, Loop} from '../navigation';
import getVesselInForm from '../vessel/VesselInForm';

const fieldLabelMappings = mapFieldLabels(fields);

const FormSSL = () => {
    const node = FormTypes.SSL.toLowerCase();

    // add loop name context to field name here, with placeholder for index
    const isOffshore = {
        field: ['vessel_entries', 'vessel_type'],
        comparitor: '==',
        value: 'Offshore Installation',
    };

    const Department = RatingFactory();
    //const DepartmentOffshore = RatingFactory(true);

    return (
        <ProgressForm title={FormNames.SSL} node={node}>
            <StatePrompt />
            <Route path={`/forms/${node}/upload`}>
                <Upload documentType={node} />
            </Route>
            <Route path={`/forms/${node}/signature`}>
                <Signature />
            </Route>
            {/* Vessel info section */}
            <Loop node='vessel_entries'>
                {getVesselInForm(node, true)}
                {/* Position Info */}
                <Loop node='service_entries'>
                    <BranchGroup>
                        {/* Traditional Track */}
                        <Branch when={!isOffshore || true}>
                            {/* Service Entries section */}
                            <Route
                                path={`/forms/${node}/shipment-discharge`} // days
                            >
                                <ShipmentAndDischarge />
                            </Route>
                            <Route path={`/forms/${node}/department`}>
                                <Department />
                            </Route>
                        </Branch>
                        {/* Offshore Track */}
                        {/* <Branch when={isOffshore && false}>
                            <Route
                                path={`/forms/${node}/shipment-discharge-offshore`} // days
                            >
                                <ShipmentAndDischarge />
                            </Route>
                            <Route path={`/forms/${node}/department-offshore`}>
                                <DepartmentOffshore />
                            </Route>
                            <Route path={`/forms/${node}/offshore-trainee`}>
                                <OffshoreTrainee />
                            </Route>
                        </Branch> */}
                    </BranchGroup>

                    <Route path={`/forms/${node}/route`}>
                        <Watertype />
                    </Route>
                    <Route path={`/forms/${node}/vessel-position-summary`}>
                        <VesselPositionSummary />
                    </Route>
                </Loop>
                <Route path={`/forms/${node}/vessel-review`}>
                    <Review
                        showFormInfo
                        fieldLabelMappings={fieldLabelMappings}
                        ssl={true}
                        isEnd={false}
                    />
                </Route>
            </Loop>
            <BranchGroup>
                <Branch
                    when={state =>
                        state?.vessel_entries?.filter(
                            entry =>
                                entry.vessel_type === 'Tank Ship' ||
                                entry.vessel_type === 'Tank Barge'
                        ).length
                    }
                >
                    <Route path={`/forms/${node}/tankerman`}>
                        <AssociateTankerman />
                    </Route>
                </Branch>
            </BranchGroup>
            <Route path={`/forms/${node}/summary`}>
                <LetterSummary />
            </Route>
            <Route path={`/forms/${node}/review`}>
                <Review
                    showFormInfo
                    fieldLabelMappings={fieldLabelMappings}
                    ssl={true}
                />
            </Route>
            <BranchGroup>
                <Branch when={(state, response) => response?.errors?.length}>
                    <Route path={`/forms/${node}/errors`}>
                        <Errors />
                    </Route>
                </Branch>
                <Branch when={(state, response) => !response?.errors?.length}>
                    <Route path={`/forms/${node}/success`}>
                        <Success />
                    </Route>
                </Branch>
            </BranchGroup>
        </ProgressForm>
    );
};

export default FormSSL;
